"use strict";
/**
 * @license
 * Copyright Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CssTokenKind = void 0;
/**
 * @fileoverview List of tokens that can be produced by the CSS tokenizer.
 */
var CssTokenKind;
(function (CssTokenKind) {
    CssTokenKind[CssTokenKind["AT_KEYWORD"] = 0] = "AT_KEYWORD";
    CssTokenKind[CssTokenKind["CDC"] = 1] = "CDC";
    CssTokenKind[CssTokenKind["CDO"] = 2] = "CDO";
    CssTokenKind[CssTokenKind["CLOSE_CURLY"] = 3] = "CLOSE_CURLY";
    CssTokenKind[CssTokenKind["CLOSE_PAREN"] = 4] = "CLOSE_PAREN";
    CssTokenKind[CssTokenKind["CLOSE_SQUARE"] = 5] = "CLOSE_SQUARE";
    CssTokenKind[CssTokenKind["COLON"] = 6] = "COLON";
    CssTokenKind[CssTokenKind["COMMA"] = 7] = "COMMA";
    CssTokenKind[CssTokenKind["DELIM"] = 8] = "DELIM";
    CssTokenKind[CssTokenKind["DIMENSION"] = 9] = "DIMENSION";
    CssTokenKind[CssTokenKind["EOF"] = 10] = "EOF";
    CssTokenKind[CssTokenKind["FUNCTION"] = 11] = "FUNCTION";
    CssTokenKind[CssTokenKind["HASH"] = 12] = "HASH";
    CssTokenKind[CssTokenKind["IDENT"] = 13] = "IDENT";
    CssTokenKind[CssTokenKind["NUMBER"] = 14] = "NUMBER";
    CssTokenKind[CssTokenKind["OPEN_CURLY"] = 15] = "OPEN_CURLY";
    CssTokenKind[CssTokenKind["OPEN_PAREN"] = 16] = "OPEN_PAREN";
    CssTokenKind[CssTokenKind["OPEN_SQUARE"] = 17] = "OPEN_SQUARE";
    CssTokenKind[CssTokenKind["PERCENTAGE"] = 18] = "PERCENTAGE";
    CssTokenKind[CssTokenKind["SEMICOLON"] = 19] = "SEMICOLON";
    CssTokenKind[CssTokenKind["STRING"] = 20] = "STRING";
    CssTokenKind[CssTokenKind["WHITESPACE"] = 21] = "WHITESPACE";
})(CssTokenKind = exports.CssTokenKind || (exports.CssTokenKind = {}));
